export enum DOCUMENT_TYPE {
  quote = 0,
  order,
  deliveryNote,
  invoice,
  receipt,
  deliveryNoteRefund,
  invoiceRefund,
  generalLedgerReport,
  purchaseOrder,
  purchaseInvoice,
  purchaseInvoiceRefund,
  boardMission,
  customerChat,
  supplierPayments,
  proformaInvoice = 14,
  QuoteApprovalRequest = 17,
}

export enum QUOTE_STATUSES {
  Create = 1,
  Open = 2,
  Closed = 3,
  Canceled = 4,
  Waiting = 5,
  Approved = 6,
  CanceledIrrelvant = 7,
  CanceledPrice = 8,
  CanceledDeliveryTime = 9,
  CanceledOther = 10,
  ApprovedByManager = 11,
  RejectedByManager = 12,
  PartialClosed = 13,
  WaitForPrintHouseConfirm = 14,
  WaitingForApproval = 15,
  CanceledDuplicate = 16,
}

export enum DELIVERY_NOTE_STATUSES {
  Open = 0,
  Canceled,
  Created,
  Refunded,
  Confirmed,
  Rejected,
  PartialRefunded,
  ClosedAsInvoice,
  ClosedByMultiDocuments,
  ManualClose,
}

export enum PROFORMA_INVOICE_STATUSES {
  Open = 0,
  Canceled,
  Created,
  Refunded,
  Confirmed,
  Rejected,
  PartialRefunded,
  ClosedAsInvoice,
  ClosedByMultiDocuments,
  ManualClose,
}

export enum EStatisticsLabels {
  SUCCESS_RATE = "successRate",
  MONTHLY_PERFORMANCE = "monthlyPerformance",
  TARGET_PERCENTAGE = "targetPercentage",
  APPROVED = "approved",
  WAITING = "waiting",
  PENDING = "pending",
  ORDERS = "orders",
  ORDERS_TOTAL = "ordersTotal",
  TOTAL_QUOTES = "totalQuotes",
  TOTAL_INVOICES = "totalInvoices",
  TOTAL_RECEIPTS = "totalReceipts",
  CANCELED = "canceled",
  STUCK_JOBS = "stuckJobs",
  JOBS_WAITING_FOR_APPROVAL = "jobsWaitingForApproval",
}

export enum LogActionType {
  ITEM_ADD = 1,
  ITEM_UPADTED,
  ITEM_DELETED,
  ITEM_PRICE_UPDATE,
  DOCUMENT_PRICE_UPDATE,
  DOCUMENT_DISCUOUNT_UPDATE,
  ADDRESS_UPDATED,
  CONTACTS_UPDATED,
  CLIENT_UPDATED,
  AGENT_UPDATED,
  PURCHASE_NUMBER_UPDATE,
  COMMENTS_UPDATE,
  DOCUMENT_DUPLICATED,
  DOCUMENT_DUPLICATED_FROM_ORDER,
  SEND_MAIL,
  SEND_SMS,
  PRINTING_PDF,
  DOCUMENT_CANCEL,
  REJECTED_BY_CLIENT,
  APPROVAL_BY_CLIENT,
  ADD,
  CLOSE,
  SEND_READY_BOARDMISSION_MAIL,
  SEND_READY_BOARDMISSION_SMS,
  SEND_READY_ORDER_MAIL,
  SEND_READY_ORDER_SMS,
  PAYMENT_LINK_GENERATED,
  PAYMENT_SUCCESS,
  PAYMENT_FAILED,
  MOVE_JOB_TO_READY,
  CURRENCY_UPDATE,
  ITEM_DETAILS_UPDATE,
  ITEM_SELECTED,
  ITEM_UNSELECTED,
  DOCUMENT_TITLE_UPDATE,
  DELIVERY_ADDRESS_ADD,
  BILLING_ADDRESS_ADD,
  DELIVERY_ADDRESS_UPDATED,
  BILLING_ADDRESS_UPDATED,
  DELIVERY_ADDRESS_REMOVE,
  BILLING_ADDRESS_REMOVE,
  DOCUMENT_APPROVAL_BY_MANAGER,
  DOCUMENT_OPENED_BY_EMPLOYEE,
  DELIVERY_ITEM_ADD,
  FULLY_DELIVERED,
  PARTIAL_DELIVERED,
  REMOVE_DELIVERED,
  BACK_JOB_TO_PRODUCTION,
  PACKAGING_SLIP_PRINTED_FOR_JOB,
  PACKAGING_SLIP_PRINTED_FOR_ORDER,
  DOCUMENT_DELIVERY_DATE_UPDATE,
  TAX_CONFIRMATION_NUMBER_UPDATE,
  SEND_FRONTDESK,
}

export enum ApprovalStatus {
  SentToManagerApproval = 1,
  ApprovedByManager,
  RejectedByManager,
  WaitingForClient,
  ApprovedByClient,
  RejectedByClient,
}

export enum StatusTitleText {
  QuoteCreate = "Quote.Create",
  OrderClosed = "Order.Closed",
  OrderPaused = "Order.Paused",
  OrderCanceled = "Order.Canceled",
  PurchaseOrderOpen = "PurchaseOrder.Open",
  PurchaseOrderCanceled = "PurchaseOrder.Canceled",
  PurchaseOrderClosed = "PurchaseOrder.Closed",
  DeliveryNoteOpen = "DeliveryNote.Open",
  DeliveryNoteClosed = "DeliveryNote.Closed",
  DeliveryNotePartialClosed = "DeliveryNote.PartialClosed",
  InvoiceOpen = "Invoice.Open",
  InvoiceClosed = "Invoice.Closed",
  ProformaInvoiceOpen = "ProformaInvoice.Open",
  ProformaInvoiceClosed = "ProformaInvoice.Closed",
}

export enum PURCHASE_ORDER_STATUSES {
  Open = 0,
  Canceled,
  ClosedAsDeliveryNote,
  ClosedAsInvoice,
  PartiallyClosed,
  ClosedByMultiDocuments,
  WaitingForPayment,
  Draft,
  Closed,
  ManualClose,
}
export enum INVOICES_EXPORT_TYPES {
  Excel = 0,
  ExtendedExcel,
  ExtendedTxt,
  SummeryExcelWithoutVat,
  SummeryExcelWithVat,
}
